import { Component, OnInit } from '@angular/core';
import { HttpService } from 'src/app/http.service';
import { ThemePalette, ProgressSpinnerMode } from '@angular/material';
import { DomSanitizer } from '@angular/platform-browser';
import { GlobalService } from 'src/app/global.service';

@Component({
  selector: 'app-total-sale-per-day',
  templateUrl: './total-sale-per-day.component.html',
  styleUrls: ['./total-sale-per-day.component.scss']
})
export class TotalSalePerDayComponent implements OnInit {
  selected_date: any = new Date().toISOString().split('T')[0];
  is_document_available: boolean = true;
  is_data_available: boolean = true;
  document_details: any = null;
  color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'indeterminate';
  total_sale_details: any;
  test_data: any;
  title = null;
  pdf_data: any;
  constructor(private httpService: HttpService, private dom: DomSanitizer, private global: GlobalService) {
    this.title = this.global._active_display_name;
  }

  getClicked() {

    let data_dict = {
      'selected_date': this.selected_date
    };
    this.is_document_available = false;
    this.httpService.serveTotalSaleForSelectedDateCounterWise(data_dict).subscribe((data) => {
      console.log(data);
      this.pdf_data = this.dom.bypassSecurityTrustResourceUrl('data:application/pdf;base64,' + data['pdf']);
      this.document_details = data;
      this.is_document_available = true;
    }, (error) => {
      this.is_document_available = true;
    });
  }

  downloadReportCliked() {
      const linkSource = 'data:application/pdf;base64,' + this.document_details['pdf'];
      // this.test_data = this.dom.bypassSecurityTrustResourceUrl(linkSource);
      const downloadLink = document.createElement("a");
      const fileName = this.document_details['file_name'];
      downloadLink.href = linkSource;
      downloadLink.download = fileName;
      downloadLink.click();
  }

  getPdf() {
    return this.dom.bypassSecurityTrustResourceUrl(this.pdf_data);
  }

  ngOnInit() {
  }

}
